module.exports = highcharts;